import { updatesData } from '@/mocks/comics';

const typeStyles: Record<string, string> = {
  '韩漫': 'bg-accent-50 text-accent-600',
  '日漫': 'bg-primary-50 text-primary-600',
  '国漫': 'bg-secondary-50 text-secondary-600',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            追更动态
          </h2>
          <p className="text-sm text-foreground-500">
            实时追踪最新更新的漫画章节
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative">
            <div className="absolute left-4 md:left-5 top-3 bottom-3 w-px bg-background-200"></div>
            <div className="space-y-1">
              {updatesData.map((update, index) => (
                <a
                  key={update.id}
                  href="#updates"
                  className="group flex items-center gap-4 md:gap-5 px-0 py-3 relative cursor-pointer"
                >
                  <div className={`relative z-10 w-3 h-3 rounded-full border-2 flex-shrink-0 ${
                    index === 0 ? 'bg-accent-500 border-accent-500' :
                    index === 1 ? 'bg-primary-500 border-primary-500' :
                    index === 2 ? 'bg-secondary-500 border-secondary-500' :
                    'bg-background-300 border-background-300'
                  }`}></div>

                  <div className="flex-1 min-w-0 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
                    <div className="flex items-center gap-3 min-w-0">
                      <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                        {update.title}
                      </h3>
                      <span className={`flex-shrink-0 text-xs px-2 py-0.5 rounded ${typeStyles[update.type]}`}>
                        {update.type}
                      </span>
                    </div>
                    <span className="text-xs text-foreground-500 flex-shrink-0 flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      {update.time}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}